export const ROLE_CLAIM_KEYS = [
  'https://gocrisp.com/roles',
  'https://crisp.com/roles',
  'roles',
] as const;

const ADMIN_ROLE_TOKENS = new Set([
  'admin',
  'superadmin',
  'superuser',
  'role:admin',
  'role:superadmin',
  'role:superuser',
]);

export const AUTHORING_PERMISSION = 'edit:pages';

export function extractRolesFromClaims(source: Record<string, unknown> | null | undefined): string[] {
  if (!source) return [];
  const roles: string[] = [];
  for (const key of ROLE_CLAIM_KEYS) {
    const value = source[key];
    if (Array.isArray(value)) {
      for (const item of value) {
        if (item !== undefined && item !== null && String(item).trim()) {
          roles.push(String(item));
        }
      }
    } else if (typeof value === 'string' && value.trim()) {
      roles.push(value);
    }
  }
  return [...new Set(roles)];
}

export function isDocsAdmin(roles: string[] | null | undefined): boolean {
  if (!roles || roles.length === 0) return false;
  return roles.some((role) => ADMIN_ROLE_TOKENS.has(role.toLowerCase()));
}

export function hasAuthoringAccess(
  roles: string[] | null | undefined,
  permissions: string[] | null | undefined
): boolean {
  return (
    isDocsAdmin(roles) ||
    Boolean(
      permissions?.some(
        (permission) => permission === AUTHORING_PERMISSION || permission === '*'
      )
    )
  );
}
